import { useRef, useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { Avatar } from "@/components/PersonCard";
import { uploadImage, errMsg } from "@/lib/api";
import { toast } from "sonner";
import { t } from "@/lib/i18n";

export const PhotoUpload = ({ value, name, onChange, testid = "photo-upload" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const { url } = await uploadImage(file);
      onChange(url);
      toast.success("Photo uploaded");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  return (
    <div className="flex items-center gap-4">
      <Avatar p={{ name: name || "?", photo_url: value }} size="w-16 h-16 text-lg" />
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={`${testid}-btn`}
        className="inline-flex items-center gap-2 h-10 px-4 rounded-full border border-[#E5DEC9] bg-white text-sm hover:border-[#1E3A2B] transition-colors">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Camera className="w-4 h-4" />}
        {value ? t("Change photo") : t("Upload photo")}
      </button>
      {value && <button type="button" onClick={() => onChange("")} className="text-xs text-[#C62828]" data-testid={`${testid}-remove`}>{t("Remove")}</button>}
    </div>
  );
};
